<ng-container *transloco="let t" class="container">
  <div class="form-floating {{cssClass ? cssClass : ''}}">
    <div class="form-check form-switch d-flex align-items-center">
      <input type="checkbox" id="{{formId}}" [class.ng-invalid]="control.touched && control.invalid" class="form-check-input" [placeholder]="placeholder ?
      t(placeholder) :
           t(label!)" [formControl]="control">
      @if (label) {
        <label class="form-check-label" for="{{formId}}">
          <p class="regular">
            {{
              t(label!)
            }}@if (control.errors?.['required']) {
            <span>*</span>
          }
          </p>
        </label>
      }
      @if (control.touched && !hideErrorMessage) {
        @for (errorMessage of control.errors | errorMessages:formControlName;track errorMessage) {
          <div class="errorMes pt-1">
            {{errorMessage}}
          </div>
        }
      }
    </div>
  </div>
</ng-container>
